import { isNumber, isString } from "../utils/schemaUtils";

export interface GitHubDiscussion {
  id: string;
  repo: string;
  number: number;
  reference: string;
  title: string;
  category?: string;
  author?: string;
  answered: boolean;
  commentCount: number;
  url: string;
  createdAt: string;
  updatedAt: string;
}

export const isGitHubDiscussion = (v: unknown): v is GitHubDiscussion => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.repo) &&
    isNumber(r.number) &&
    isString(r.reference) &&
    isString(r.title) &&
    (r.category === undefined || isString(r.category)) &&
    (r.author === undefined || isString(r.author)) &&
    typeof r.answered === "boolean" &&
    isNumber(r.commentCount) &&
    isString(r.url) &&
    isString(r.createdAt) &&
    isString(r.updatedAt)
  );
};

// An empty list also describes a repository with the Discussions feature turned
// off; the two are indistinguishable from the API.
export interface GitHubDiscussionsPayload {
  type: "github_discussions";
  repo: string;
  discussions: GitHubDiscussion[];
  hasMore: boolean;
}

export const parseGitHubDiscussionsPayload = (v: unknown): GitHubDiscussionsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_discussions") return null;
  if (!isString(r.repo)) return null;
  if (!Array.isArray(r.discussions) || !r.discussions.every(isGitHubDiscussion)) return null;
  if (typeof r.hasMore !== "boolean") return null;
  return {
    type: "github_discussions",
    repo: r.repo,
    discussions: r.discussions,
    hasMore: r.hasMore,
  };
};
